import type React from 'react';
import { useTranslation } from 'react-i18next';

import { getRouteApi } from '@tanstack/react-router';
import {
  BuildingIcon,
  CloudDownloadIcon,
  FileTextIcon,
  FolderOpenIcon,
  HouseIcon,
  MapPinIcon,
} from 'lucide-react';

import { cn } from '@/lib/utils';

import { NavbarLink } from '../ui/navbar-link';

export type DashboardNavProps = React.ComponentProps<'nav'>;

const route = getRouteApi('/_authenticated/_sidebar-layout');

export const DashboardNav = ({ className, ...props }: DashboardNavProps) => {
  const { t } = useTranslation();
  const { projectId } = route.useParams();

  return (
    <nav className={cn('flex justify-between gap-1', className)} {...props}>
      {projectId ? (
        <>
          <NavbarLink
            title={t('projectDashboard')}
            icon={<BuildingIcon />}
            to="/projects/$projectId"
            activeOptions={{
              exact: true,
            }}
          >
            {t('projectDashboard')}
          </NavbarLink>
          <NavbarLink
            title={t('objectDashboard')}
            icon={<HouseIcon />}
            to="/projects/$projectId/objects"
          >
            {t('objectDashboard')}
          </NavbarLink>
          <NavbarLink
            title={t('mediaDatabase')}
            to="/projects/$projectId/media"
            icon={<FolderOpenIcon />}
          >
            {t('mediaDatabase')}
          </NavbarLink>
          <NavbarLink
            title={t('documents')}
            to="/projects/$projectId/documents"
            icon={<CloudDownloadIcon />}
          >
            {t('documents')}
          </NavbarLink>
        </>
      ) : (
        <>
          <NavbarLink
            title={t('objectDashboard')}
            icon={<MapPinIcon />}
            to="/estates/$estateId"
            activeOptions={{
              exact: true,
            }}
          >
            {t('objectDashboard')}
          </NavbarLink>
          <NavbarLink
            title={t('mediaDatabase')}
            to="/estates/$estateId/media"
            icon={<FolderOpenIcon />}
          >
            {t('mediaDatabase')}
          </NavbarLink>
          <NavbarLink
            title={t('analytics')}
            to="/estates/$estateId/analytics"
            icon={<FileTextIcon />}
          >
            {t('analytics')}
          </NavbarLink>
          <NavbarLink
            title={t('documents')}
            to="/estates/$estateId/documents"
            icon={<CloudDownloadIcon />}
          >
            {t('documents')}
          </NavbarLink>
        </>
      )}
    </nav>
  );
};
